/* eslint-disable no-unused-vars */
import moment from 'moment';
import momentz from 'moment-timezone';
import { disabledDates } from '../../Calender';

export const is_weekend = function (date) {
  let day = moment(date);
  const dow = day.day();
  let endingTime = moment('9:30am', 'h:mma');
  let startingTime = moment('12:01am', 'h:mma');
  let nowTxt = momentz().tz('America/New_York').format('h:mma');
  let convertedText = moment(nowTxt, 'h:mma');
  const checkHoliday = moment(date, 'YYYY-MM-DD')
    .subtract(1, 'days')
    .format('YYYY-MM-DD');
  if (disabledDates && disabledDates.length) {
    switch (true) {
      case disabledDates.includes(moment(date).format('YYYY-MMM-DD')):
        if (dow === 1) {
          return moment(date, 'YYYY-MM-DD')
            .subtract(3, 'days')
            .format('YYYY-MM-DD');
        } else {
          return moment(date, 'YYYY-MM-DD')
            .subtract(1, 'days')
            .format('YYYY-MM-DD');
        }

      case dow === 6:
        return moment(date, 'YYYY-MM-DD')
          .subtract(1, 'day')
          .format('YYYY-MM-DD');

      case dow === 0:
        return moment(date, 'YYYY-MM-DD')
          .subtract(2, 'days')
          .format('YYYY-MM-DD');

      case dow === 1 &&
        moment(convertedText).isBefore(endingTime) &&
        moment(convertedText).isAfter(startingTime):
        return moment(date, 'YYYY-MM-DD')
          .subtract(3, 'days')
          .format('YYYY-MM-DD');

      case moment(convertedText).isBefore(endingTime) &&
        moment(convertedText).isAfter(startingTime) &&
        moment(date).isSame(new Date(), 'day'):
        if (
          disabledDates.includes(moment(checkHoliday).format('YYYY-MMM-DD'))
        ) {
          const dayBeforeChekHoliday = moment(checkHoliday, 'YYYY-MM-DD')
            .subtract(1, 'days')
            .format('YYYY-MM-DD');
          let dayBeforeChekHolidayDay = moment(dayBeforeChekHoliday);
          const dayBeforeChekHolidayDayFind = dayBeforeChekHolidayDay.day();
          if (dayBeforeChekHolidayDayFind === 0) {
            return moment(date, 'YYYY-MM-DD')
              .subtract(4, 'day')
              .format('YYYY-MM-DD');
          } else {
            return moment(date, 'YYYY-MM-DD')
              .subtract(2, 'day')
              .format('YYYY-MM-DD');
          }
        } else {
          return moment(date, 'YYYY-MM-DD')
            .subtract(1, 'day')
            .format('YYYY-MM-DD');
        }

      default:
        return date;
    }
  }
};
export const is_WeekendCalendarDate = function (date) {
  let dt = new Date(date);
  let day = moment(date);
  const dow = day.day();
  switch (true) {
    case dow === 6:
      return moment(date, 'YYYY-MM-DD').subtract(1, 'day').format('YYYY-MM-DD');

    case dow === 0:
      return moment(date, 'YYYY-MM-DD')
        .subtract(2, 'days')
        .format('YYYY-MM-DD');
    default:
      return date;
  }
};

export const weekendCheck = function (date) {
  let day = moment(date);
  const dow = day.day();
  if (dow === 6 || dow === 0) {
    return true;
  } else {
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/components/Modals/UOAModal/getDate.js